import React, {createContext, ReactNode, useContext} from "react";

interface DrawerContextProviderProps {
    children: ReactNode;
    title: string;
    setTitle: React.Dispatch<React.SetStateAction<string>>
}

export function useTopBarContext() {
    const context = useContext(TopBarContext);
    if (context === undefined) {
        throw new Error('topBarContext must be called within its Provider')
    }
    return context;
}

type TopBarContextProps = {
    title: string; setTitle: React.Dispatch<React.SetStateAction<string>>
};

const TopBarContext = createContext({} as TopBarContextProps)

export default function TopBarContextProvider({title, setTitle, children}: DrawerContextProviderProps) {

    return (<TopBarContext.Provider value={{title, setTitle}}>
        {children}
    </TopBarContext.Provider>);

}